<template>
  <el-dialog
    title="留言板详情"
    :visible="true"
    width="700px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="
      () => {
        handleClose(false)
      }
    "
  >
    <el-form ref="form" :model="form" label-width="120px" :rules="rules">
      <el-form-item label="来源">
        <el-input
          disabled
          v-model="form.source"
          type="textarea"
          :autosize="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系人姓名">
        <el-input
          disabled
          v-model="form.name"
          type="textarea"
          :autosize="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系人手机号">
        <el-input
          disabled
          v-model="form.phone"
          type="textarea"
          :autosize="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="单位名称">
        <el-input
          disabled
          v-model="form.unitName"
          type="textarea"
          :autosize="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="需求描述">
        <el-input
          disabled
          v-model="form.content"
          type="textarea"
          :autosize="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="邮箱">
        <el-input
          disabled
          v-model="form.email"
          type="textarea"
          :autosize="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remarks">
        <el-input
          v-model="form.remarks"
          maxlength="200"
          type="textarea"
          :autosize="true"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="write-footer">
      <el-button class="search-but1" size="small" @click="handleClose(false)">
        取消
      </el-button>
      <el-button size="small" type="primary" @click="handleSubmit">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import * as API from '../../api/message/index'
export default {
  name: 'MessageBoardWrite',
  props: ['handleClose', 'defaultData'],
  data() {
    return {
      form: {
        ...this.defaultData
      },
      rules: {
        remarks: [
          { required: true, message: '请填写备注后保存', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleSubmit() {
      this.$refs.form.validate(async (validate) => {
        if (validate) {
          try {
            const { id, remarks } = this.form
            const data = { id, remarks }
            const res = await API.addMessageRemarks(data)
            const { code } = res
            if (code === 0) {
              this.$message.success('保存成功')
              this.handleClose(true)
            }
          } catch (error) {}
        }
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.write-footer {
  text-align: right;
}
</style>